import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class tagsDisplayListCtrl implements IController {
  ids: any;
  isRow: any;
  rowLimit: any;
  isExcludeMode: boolean;
  onChange: Function;

  private tagsRef: any;
  private displayItems: any;

  /* @ngInject */
  constructor(private $tags, private $log) {
  }

  $onInit() {
    this.tagsRef = this.$tags();

    if (!this.rowLimit) {
      this.rowLimit = 10;
    }

    this.setItems(this.ids);
  }

  $onChanges(changes) {
    if (changes.ids && !changes.ids.isFirstChange()) {
      this.setItems(this.ids);
    }
  }

  onRemoveItem(id) {
    this.onChange({
      ids: _.filter(this.ids, (i) => {
        return i !== id
      })
    });
  }

  onReset() {
    this.onChange({ids: []});
  }

  private setItems(ids) {
    this.displayItems = (ids && ids.length) ? ids : [];
  }


}

angular
  .module('bringoz.admin.tags')
  .component('tagsDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      rowLimit: '<?',
      isExcludeMode: '<?',
      onChange: '&?'
    },
    template: require('./tags-display-list.html').default,
    controller: tagsDisplayListCtrl
  });
